import { ContactPersonModel } from "./ContactPersonModel";
import { MembershipAddressModel } from "./MembershipAddressModel";



export class MembershipModel {
    contactPerson: ContactPersonModel[];
    companyServices: string[];
   // address: MembershipAddressModel[];
    companyId: string;
    companyName: string;
    companyEmail: string;
    companyLogo: string;
    primaryPhoneNumber: string;
    secondaryPhoneNumber: string;
    websiteUrl: string;
    accountingEmail: string;
    addressLine1: string;
    addressLine2: string;
    cityId: number;
    stateId: number;
    countryId: number;
    countryName: string;
    cityName: string;
    zipCode: string;
    companyDetails: string;
    instagramUrl: string;
    linkedinUrl: string;
    twitterUrl: string;
    facebookUrl: string;
    youtubeUrl: string;
    membershipType: string;
    status: string;
    isSelected: boolean;
    stateName: string;
    serviceId: string;
    country: number;
    password: string;
    userName: string;
    isHeadOffice: boolean;
    expiryDate: string;


    constructor() {
        this.contactPerson = [];
        this.companyServices = [];
        //this.address = [];
        this.companyId = "";
        this.companyName = "";
        this.companyEmail = "";
        this.companyLogo = "";
        this.primaryPhoneNumber = "";
        this.secondaryPhoneNumber = "";
        this.websiteUrl = "";
        this.accountingEmail = "";
        this.addressLine1="";
        this.cityId=null;
        this.stateId=null;
        this.stateName="";
        this.countryId=null;
        this.countryName="";
        this.zipCode="";
        this.companyDetails = "";
        this.instagramUrl = "";
        this.linkedinUrl = "";
        this.twitterUrl = "";
        this.facebookUrl = "";
        this.youtubeUrl = "";
        this.membershipType = "";
        this.status = "";
        this.isSelected = false;
        //this.countryId = 0;
        this.serviceId = "";
        this.password = "";
        this.userName = "";
        this.cityName = "";
        this.isHeadOffice = false;

        this.expiryDate = "";
    }
}